import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import { connect } from 'react-redux';
import Flexbox from 'flexbox-react';
import SecurityService from '../../../services/SecurityService';
import AbstractFilteredList from '../../core/AbstractFilteredList';
import ListItem from '../../core/ListItem';
import { Checkbox } from 'react-bootstrap';

const filterBox = css`
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-top: 5px;
    label {
        line-height: 20px;
    }
`;

const deprecatedColor = css`
    color: darkgray;
`;

class ProcessCatalog extends AbstractFilteredList {
    static propTypes = {
        userLoggedIn: PropTypes.bool,
        writableProcesses: PropTypes.object
    };

    /**
     * Is the production checkbox checked or not?
     * @returns {*|boolean}
     */
    getIsProduction() {
        return this.getLSState().isProduction || false;
    }

    /**
     * Is the derpecated checkbox checked or not?
     * @returns {*|boolean}
     */
    getIsDeprecated() {
        return this.getLSState().isDeprecated || false;
    }

    /**
     * Is the VAP checkbox checked or not?
     * @returns {*|boolean}
     */
    getIsVAP() {
        return this.getLSState().isVAP || false;
    }

    /**
     * Is the Ingest checkbox checked or not?
     * @returns {*|boolean}
     */
    getIsIngest() {
        return this.getLSState().isIngest || false;
    }

    getIsOwnedByUser() {
        return this.getLSState().isOwnedByUser || false;
    }

    getItemClassName() {
        return 'process';
    }

    getListClassName() {
        return 'process-catalog';
    }

    getInputClassName() {
        return 'filter-input';
    }

    getPlaceholder() {
        return 'Filter by name or partial name';
    }

    getWritableProcesses = () => {
        let writableProcesses = null;
        if (this.props.writableProcesses) {
            writableProcesses = Object.keys(this.props.writableProcesses);
        }
        return writableProcesses;
    };

    match(regex, name, value) {
        const production = this.getIsProduction();
        const deprecated = this.getIsDeprecated();
        const vap = this.getIsVAP(); // vap filter checked
        const ingest = this.getIsIngest(); // ingest filter checked
        const owner = this.getIsOwnedByUser();
        const writableProcesses = this.getWritableProcesses();
        const nameMatch = (name.search(regex) > -1);

        let stateMatch = true;
        if (deprecated && production) {
            stateMatch = value.prod;
        } else if (production) {
            stateMatch = value.prod && !value.deprecated
        } else if (deprecated) {
            stateMatch = value.deprecated;
        }
        
        const ownerMatch = !owner || !writableProcesses || writableProcesses.indexOf(value.id) > -1;

        let typeMatch = true;
        if (vap && ingest) {
            typeMatch = value.type === 'VAP' || value.type === 'Ingest';
        } else if (vap) {
            typeMatch = value.type === 'VAP';
        } else if (ingest) {
            typeMatch = value.type === 'Ingest';
        }

        return nameMatch && stateMatch && typeMatch && ownerMatch;
    }

    onProductionChecked = () => {
        this.setLSState({ isProduction: this.prodCheckbox.checked });
    };

    onDeprecatedChecked = () => {
        this.setLSState({ isDeprecated: this.deprecatedCheckbox.checked });
    }

    onVAPChecked = () => {
        this.setLSState({ isVAP: this.vapCheckbox.checked });
    };

    onIngestChecked = () => {
        this.setLSState({ isIngest: this.ingestCheckbox.checked });
    };

    onOwnedByMeChecked = () => {
        this.setLSState({ isOwnedByUser: this.ownedByMeCheckbox.checked });
    };

    renderItem = (name, value, selected) => {
        let iconStyle = 'fa fa-cogs yellow';
        
        if (value.deprecated) {
            iconStyle = `fa fa-cogs ${deprecatedColor}`;
        } else if (value.prod) {
            iconStyle = 'fa fa-cogs green';
        }
        

        return (
            <ListItem
                key={name}
                name={name}
                className={this.getItemClassName()}
                selected={selected}
                onClick={this.onClick}
                onDoubleClick={this.props.onDoubleClick}
            >
                <i className={iconStyle} aria-hidden="true" />
                {name}
                <div className="type">{value.type}</div>
            </ListItem>
        );
    };


    renderCheckboxFilters() {
        const isProduction = this.getIsProduction();
        const isDeprecated = this.getIsDeprecated();
        const isVAP = this.getIsVAP();
        const isIngest = this.getIsIngest();
        const isOwnedByUser = this.getIsOwnedByUser();
        const prodRef = (ref) => {
            this.prodCheckbox = ref;
        };
        const depRef = (ref) => {
            this.deprecatedCheckbox = ref;
        };
        const vapRef = (ref) => {
            this.vapCheckbox = ref;
        };
        const ingestRef = (ref) => {
            this.ingestCheckbox = ref;
        };
        const ownedRef = (ref) => {
            this.ownedByMeCheckbox = ref;
        };

        return (
            <span className={filterBox}>
                <Flexbox flexDirection="row">
                    <Checkbox inputRef={prodRef} inline onChange={this.onProductionChecked} checked={isProduction}>
                        <i className="fa fa-cogs green" aria-hidden="true" /> Prod (DMF)
                    </Checkbox>
                    <Checkbox inputRef={depRef} inline onChange={this.onDeprecatedChecked} checked={isDeprecated}>
                        <i className={`fa fa-cogs ${deprecatedColor}`} aria-hidden="true" /> Deprecated
                    </Checkbox>
                </Flexbox>
                <Flexbox flexDirection="row">
                    <Checkbox inputRef={vapRef} inline onChange={this.onVAPChecked} checked={isVAP}>VAP</Checkbox>
                    <Checkbox inputRef={ingestRef} inline onChange={this.onIngestChecked} checked={isIngest}>Ingest</Checkbox>
                    { this.props.userLoggedIn ?
                        <Checkbox
                            style={{ paddingLeft: '10px' }}
                            inputRef={ownedRef}
                            inline
                            onChange={this.onOwnedByMeChecked}
                            checked={isOwnedByUser}>Owned by Me
                        </Checkbox>
                        : ''
                    }
                </Flexbox>
            </span>
        );
    }
}

// Automatically pull state information from the store and
// pass it to this component as props
const mapStateToProps = (storeState) => {
    const securityState = SecurityService.getMyState(storeState);
    return {
        userLoggedIn: securityState.userLoggedIn,
        writableProcesses: securityState.writableProcesses
    };
};

export default connect(mapStateToProps)(ProcessCatalog);



// WEBPACK FOOTER //
// ./src/components/page/process/ProcessCatalog.js